export const GradientColors = {
  blue: `transparent linear-gradient(284deg, #007CFF 0%, #00338D 100%) 0% 0% no-repeat padding-box;`,
  green: 'linear-gradient(270deg, #00cec9 0%, #81ecec 100%)',
  amber: 'linear-gradient(90deg, #fdcb6e 0%, #ffeaa7 100%)',
  red: 'linear-gradient(90deg, #e64748 0%, #ff7675 100%)',
  default: 'linear-gradient(270deg, #808080 0%, #b3b3b3 100%)',
};
